import { FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
interface IControlledRadioGroup {
  options: any[];
  onChange?: (value: string[]) => void;
  value: string | string[];
  hasError?: boolean;
  dataTestIdSuffix: string;
}
export default function ControlledRadioGroup({
  options,
  onChange,
  value,
  hasError,
  dataTestIdSuffix
}: IControlledRadioGroup) {
  const {
    t
  } = useTranslation('needsBasedQuestions');
  return <FormControl required sx={{
    mb: 2
  }} data-sentry-element="FormControl" data-sentry-component="ControlledRadioGroup" data-sentry-source-file="ControlledRadioGroup.tsx">
			<RadioGroup aria-labelledby={dataTestIdSuffix} name="controlled-radio-buttons-group" value={value} onChange={(_, value: string) => onChange?.([value])} data-sentry-element="RadioGroup" data-sentry-source-file="ControlledRadioGroup.tsx">
				{options.map(option => <FormControlLabel value={option.value} control={<Radio />} label={<Typography variant="bodyMediumBook" color="text.secondary">
								{option.label}
							</Typography>} key={option.value} />)}
			</RadioGroup>
			{hasError && (!value || value.length === 0) ? <FormHelperText sx={{
      m: 0
    }}>
					<Typography variant="errorValidation">{t('required')}</Typography>
				</FormHelperText> : null}
		</FormControl>;
}